import { render } from "./TarifaConv_TarifaPres.vue?vue&type=template&id=6ff98994"
import script from "./TarifaConv_TarifaPres.vue?vue&type=script&lang=js"
export * from "./TarifaConv_TarifaPres.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__